export default __webpack_public_path__ + "static/4-fef7b1a014e1669ac38abd7c49b9c254.jpg";